import { TimelineEvent } from '@src/types';
import {
  ButtonType,
  TemplateType,
} from '@src/components/AdminHome/Channels/WhatsApp/WhatsAppTemplates/types';
import { TemplateWithFlowContentTypes } from './types';

export const getButtonFromTemplateMessage = (message: TimelineEvent) =>
  message?.content?.filter(
    it => it.type === TemplateWithFlowContentTypes.BUTTONS
  )[0];

export const isTemplateWithFlow = (message: TimelineEvent) => {
  const button = getButtonFromTemplateMessage(message);
  return button?.buttons?.[0].type === ButtonType.FLOW;
};

// A template sent through the "request phone number" flow carries Meta's
// REQUEST_CONTACT_INFO button. The backend validates it is the only button of the
// template, so any button of that type identifies the template kind. The console
// models that button as the TemplateType.REQUEST_CONTACT_INFO component (see the
// template preview), hence the constant compared here.
export const isTemplateWithRequestContactInfo = (message: TimelineEvent) => {
  const button = getButtonFromTemplateMessage(message);
  return !!button?.buttons?.some(
    it => it.type === TemplateType.REQUEST_CONTACT_INFO
  );
};

export default getButtonFromTemplateMessage;
